import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { getIdStitchValues } from '@tr/tr-id-stitch';

import 'zone.js'; 

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
  
const idStitchCall = async () => {
  const userName = localStorage.getItem('username');
  if (userName !== null) {
    await getIdStitchValues(userName).then(
      value => {
        localStorage.setItem('idStitchEmailHash', value.emailHash);
        localStorage.setItem('idStitchAdobeEcid', value.adobeEcid);
      }
    ).catch(error => console.log(error));  
  } 
  else {
    console.log('username not found in local storage');
  }
}  

idStitchCall();